import {PrComment} from '../../interfaces/process-reports/pr-comment';
import {LightUser} from '../../interfaces/core/light-user';
import {LightUserFactory} from '../core/light-user-factory';

export class PrCommentFactory {
  /**
   *
   * @param prComment
   */
  public static fromObject(prComment: any): PrComment {
    return new class implements PrComment {
      comment: string = prComment.comment;
      created: string = prComment.created;
      id: number = prComment.id;
      modified: string = prComment.modified;
      prProcessReportId: number = prComment.pr_process_report_id;
      user: LightUser = LightUserFactory.fromObject(prComment.user);
      userId: number = prComment.user_id;
    };
  }

  /**
   *
   * @param prComments
   */
  public static fromArray(prComments: any[]): PrComment[] {
    return prComments.map(_prComment => PrCommentFactory.fromObject(_prComment));
  }

}
